<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card
          color="indigo"
          icon="mdi-content-copy"
          title="Edit template"
          class="py-3 px-5"
        >
          <v-form>
            <v-text-field color="secondary" label="Name" v-model="item.description" />

            <v-switch v-model="item.isPrioritizedInSeach" label="Prioritized in seach" />
            <v-switch v-model="item.isAdvanced" label="Advanced" />
            <v-switch v-model="item.isSetAsDefault" label="Default" />

            <v-card-actions class="pa-0 mt-5">
              <v-spacer />

              <v-btn default color="success" @click="updateItem">Update</v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>

    <div class="text-center ma-2">
      <v-snackbar v-model="Snackbar.visible" :timeout="Snackbar.timeout" :color="Snackbar.color">
        {{ Snackbar.snackbarText }}
        <v-btn dark text @click="Snackbar.visible = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import router from "../../../router";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "../../../utils/axios";

import TrainingType from "../../../servcies/api/training/TrainingType";

export default {
  name: "TrainingTypeEdit",

  components: {},

  data: () => ({
    meditor: ClassicEditor,
    content: null,
    id: null,
    item: null,
    Snackbar: {
      snackbarText: "",
      visible: false,
      timeout: 5000,
      color: "error"
    }
  }),

  created() {
    this.id = this.$route.params.id;
    if (this.$route.params.id != undefined) {
      this.id = this.$route.params.id;
      this.init();
    }
  },
  methods: {
    updateItem() {
      let loader = this.$loading.show();

      TrainingType.updateType(this.item.id, this.item)
        .then(result => {
          this.back();
          loader.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    },

    back() {
      router.go(-1);
    },

    async init() {
      this.getType(this.id);
    },

    getType(courseTypeId) {
      let loader = this.$loading.show();

      TrainingType.getType(courseTypeId)
        .then(result => {
          this.item = result;
          loader.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    }
  }
};
</script>

<style></style>
